import useSWR, { type SWRConfiguration } from 'swr';
import type SortOrder from '@/constants/SortOrder';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import fetcher from '@/lib/swr/fetcher';
import type Campaign from '@/types/api/Campaign';
import joinNonEmptyParams from '@/utils/joinNonEmptyParams';
import laggy, { type WithLaggy } from '@/utils/swr/laggy';

type CampaignSearchParams = {
  isMonetary?: boolean;
  isInKind?: boolean;
  showArchived?: boolean;
  minDonors?: number;
  maxDonors?: number;
  minDonations?: number;
  maxDonations?: number;
  userId?: string;
  pageSize?: number;
  pageFrom?: number;
  sortBy?: 'name' | 'created';
  sortOrder?: SortOrder;
};

const useCampaignSearch = (
  params: CampaignSearchParams | null = {},
  swrOptions: SWRConfiguration = {},
) => {
  const ownerOrgId = useOwnerOrgId();
  const key =
    ownerOrgId && params
      ? `orgs/${ownerOrgId}/campaigns/search?${joinNonEmptyParams(params)}`
      : null;
  const swrResponse = useSWR(
    key,
    fetcher<{ campaigns: Campaign[]; totalHits: number }>,
    { use: [laggy], ...swrOptions },
  );
  return swrResponse as WithLaggy<typeof swrResponse>;
};

export default useCampaignSearch;
